import {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import FormWrapper from '../../../../../reusable-components/Wrapper/Wrapper'
import DynamicForm from '../../../../../reusable-components/forms/DynamicForm'
import {NEW_METHOD_INPUTS} from '../../GENERAL_CONSTANTS'
import {toast} from 'react-toastify'
import {addScoringMethod} from '../store/action'
import { MoonLoader } from 'react-spinners'

const selectAuth = (state) => state.auth

export const NewMethod = () => {
  const [site, setSite] = useState([])
  const history = useHistory()
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const [clickCount, setClickCount] = useState(1)
  const [isFormLoading, setIsFormLoading] = useState(false);
  
  const [methodName, setMethodName] = useState('')

  const [inputArr, setInputArr] = useState([
    {
      levelName: '',
      levelAcronym: '',
    },
  ]);

  const onChangeLevelName = (name, value, checked, type, index) => {
    setInputArr((prev) => {
      const newArr = [...prev];
      newArr[index] = { ...newArr[index], levelName: value };
      return newArr;
    });
    setUIElements((prev) =>
      prev.map((item) => (item.name === name ? { ...item, value } : item))
    );
  };

  const onChangeLevelAcronym = (name, value, checked, type, index) => {
    setInputArr((prev) => {
      const newArr = [...prev];
      newArr[index] = { ...newArr[index], levelAcronym: value };
      return newArr;
    });
    setUIElements((prev) =>
      prev.map((item) => (item.name === name ? { ...item, value } : item))
    );
  };

  const [uiElements, setUIElements] = useState([
    {
      label: 'Method Name',
      name: 'methodName',
      index: 0,
      rowNumber: 0,
      value: methodName, 
      onChange: (name, value) => {
        setMethodName(value); 
        setUIElements(prev => 
          prev.map(item => 
            item.name === 'methodName' 
              ? { ...item, value } 
              : item
          )
        );
      }, 
      type: 'text',
      required: true,
    },
    {
      index: 1,
      rowNumber: 1,
      label: 'Level Name',
      name: '0levelName',
      value: '',
      onChange: onChangeLevelName,
      type: 'text',
      required: true,
    },
    {
      index: 1,
      rowNumber: 1,
      label: 'Level Acronym',
      name: '0levelAcronym',
      value: '',
      onChange: onChangeLevelAcronym,
      type: 'text',
      required: true,
    },
  ])

  useEffect(() => {
    setUIElements(prev => 
      prev.map(item => 
        item.name === 'methodName' 
          ? { ...item, value: methodName } 
          : item
      )
    );
  }, [methodName]);

  const onAddAnotherLevelClick = () => {
    const newIndex = inputArr.length;
    const newRowNumber = clickCount + 1;
    setInputArr(prev => [...prev, { levelName: '', levelAcronym: '' }]);
    setUIElements(prev => {
      const newElements = [...prev];
      return [
        ...newElements,
        {
          index: newIndex,
          rowNumber: newRowNumber,
          label: 'Level Name',
          name: `${newIndex}levelName`,
          value: '',
          onChange: onChangeLevelName,
          type: 'text',
          required: true,
        },
        {
          index: newIndex,
          rowNumber: newRowNumber,
          label: 'Level Acronym',
          name: `${newIndex}levelAcronym`,
          value: '',
          onChange: onChangeLevelAcronym,
          type: 'text',
          required: true,
        },
        {
          index: newIndex,
          label: 'DELETE',
          variant: 'outlined',
          type: 'button',
          onClick: () => onRemoveAnotherLevelButtonClick(newIndex),
          rowNumber: newRowNumber,
        }
      ];
    });
    setClickCount(newRowNumber);
  };

  const onRemoveAnotherLevelButtonClick = (index) => {
    setInputArr((prev) => prev.filter((_, i) => i !== index));
    setUIElements((prev) =>
      prev.filter((item) => item.index === undefined || item.index !== index)
    );
  };

  const handleSubmitForm = async (formData) => {
    let scoringLevels = inputArr.filter((eachElem) => eachElem.levelName !== '');
    
    const tempObj = {
      methodName: methodName, 
      scoringLevels: scoringLevels,
    };    
    setIsFormLoading(true);
    try {
      await dispatch(addScoringMethod(tempObj));
      toast.success('Scoring method created successfully');
      history.push('/admin/general/scoring-method/list');
    } catch (err) {
      toast.error('Error while creating scoring method');
      console.error('Error:', err);
    } finally {
      setIsFormLoading(false);
    }
  };

  const buttons = [
    {
      label: 'Add Level',
      variant: 'contained',
      type: 'button',
      onClick: onAddAnotherLevelClick,
    },
    {label: 'Cancel', variant: 'contained', type: 'button'},
    {label: 'Save', variant: 'contained', type: 'submit'}
  ]

  return (
    <FormWrapper
      title='Add New Method'
      content={
        <>
          <DynamicForm
            fields={uiElements}
            data={site}
            onSubmit={handleSubmitForm}
            buttons={buttons}
          />
        </>
      }
    />
  )
}
